var map = {
	"./egg-1.svg": "adbf",
	"./egg-2.svg": "e12f",
	"./egg-3.svg": "6015",
	"./egg-4.svg": "ec68",
	"./egg-5.jpg": "bf2e",
	"./egg-6.svg": "3b30",
	"./egg-7.png": "190f",
	"./egg-8.svg": "6a7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c42";